<template>
    <v-app id="v-app">
        <ValidationObserver
            tag="div"
            class="flex"
            id="matriculation-form-component"
            v-slot="{ invalid }"
        >
            <div class="container mx-auto px:5 md:px-8">
                <h1 class="text-center">
                    {{ trans.title }}
                </h1>
                <div class="form-grid mx-auto">
                    <div class="col flex flex-col space-y-4 md:space-y-6">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <input
                                class="wizard py-3 px-4 w-full"
                                autocomplete="off"
                                type="text"
                                v-model="form.dni"
                                name="dni"
                                :placeholder="trans.dni"
                            />
                            <span class="red" v-if="errors.length">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                        <ValidationProvider
                            :rules="{ required: true, regex: dateRegex }"
                            v-slot="{ errors }"
                        >
                            <input
                                type="text"
                                class="wizard py-3 px-4 w-full"
                                autocomplete="off"
                                v-model="form.birthDate"
                                name="birthDate"
                                :placeholder="trans.birthDate"
                            />
                            <span class="red">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <input
                                class="wizard py-3 px-4 w-full"
                                autocomplete="off"
                                type="text"
                                v-model="form.nacionality"
                                name="nacionality"
                                :placeholder="trans.nationality"
                            />
                            <span class="red">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <p class="genre-title mb-6">{{ trans.genre }}</p>
                            <div class="flex flex-col items-start space-y-6">
                                <label for="male" class="flex items-center">
                                    <input type="radio" id="male" value="M" v-model="form.genre" class="hidden" />
                                    <div class="circle mr-3" :class="{ selected: form.genre === 'M' }">
                                        <span class="inner"></span>
                                    </div>
                                    {{ trans.male }}
                                </label>
                                <label for="female" class="flex items-center">
                                    <input type="radio" id="female" value="F" v-model="form.genre" class="hidden" />
                                    <div class="circle mr-3" :class="{ selected: form.genre === 'F' }">
                                        <span class="inner"></span>
                                    </div>
                                    {{ trans.female }}
                                </label>
                                <label for="otro" class="flex items-center">
                                    <input type="radio" id="otro" value="Otro" v-model="form.genre" class="hidden" />
                                    <div class="circle mr-3" :class="{ selected: form.genre === 'Otro' }">
                                        <span class="inner"></span>
                                    </div>
                                    {{ trans.other }}
                                </label>
                                <span class="red">{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </div>
                    <div class="col flex flex-col space-y-4 md:space-y-6">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <input
                                class="wizard py-3 px-4 w-full"
                                autocomplete="off"
                                type="text"
                                v-model="form.street"
                                name="street"
                                :placeholder="trans.street"
                            />
                            <span class="red">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <input
                                class="wizard py-3 px-4 w-full"
                                autocomplete="off"
                                type="text"
                                v-model="form.streetNum"
                                name="streetNum"
                                :placeholder="trans.streetNum"
                            />
                            <span class="red">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <div>
                            <input
                                class="wizard py-3 px-4 w-full"
                                autocomplete="off"
                                type="text"
                                v-model="form.floor"
                                name="floor"
                                :placeholder="trans.floor"
                            />
                        </div>
                        <div>
                            <input
                                class="wizard py-3 px-4 w-full"
                                autocomplete="off"
                                type="text"
                                v-model="form.door"
                                name="door"
                                :placeholder="trans.door"
                            />
                        </div>
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <input
                                class="wizard py-3 px-4 w-full"
                                autocomplete="off"
                                type="text"
                                v-model="form.postalCode"
                                name="postalCode"
                                :placeholder="trans.postalCode"
                                maxlength="5"
                            />
                            <span class="red">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <input
                                class="wizard py-3 px-4 w-full"
                                autocomplete="off"
                                type="text"
                                v-model="form.location"
                                name="location"
                                :placeholder="trans.location"
                            />
                            <span class="red">{{ errors[0] }}</span>
                        </ValidationProvider>
                                        </div>
                    </div>
                <div class="flex justify-center">
                    <v-btn
                        color="primary"
                        large
                        class="mdc-button mdc-button--unelevated mdc-ripple-upgraded mdc-button__ripple unelevated block font-bold mt-12"
                        :loading="loading"
                        @click="send"
                        :disabled="buttonIsDisabled(invalid)"
                    >{{ trans['send-data'] }}</v-btn>
                </div>
            </div>
        </ValidationObserver>
        <v-snackbar v-model="snackbar" :color="snackbarType" content-class="text-center">
            {{ snackbarText }}
        </v-snackbar>
    </v-app>
</template>

<script>
import {
    ValidationProvider,
    ValidationObserver,
    localize,
    extend
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";

// Install rules and localization
Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

export default {
    props: {
        trans: {
            type: Object,
            required: true
        }
    },

    components: {
        ValidationProvider,
        ValidationObserver
    },

    data() {
        return {
            dateRegex: /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[012])\/\d{4}$/,
            selectIsOpen: false,
            selectError: false,
            locale: window.appLocale,
            email: "",
            code: "",
            locale: "",
            loading: false,
            snackbar: false,
            snackbarType: "success",
            form: {
                dni: "",
                birthDate: "",
                nacionality: "",
                genre: "",
                street: "",
                streetNum: "",
                floor: "",
                door: "",
                postalCode: "",
                location: ""
            }
        };
    },

    computed: {
        genre() {
            const genreSelected = this.form.genre;
            return genreSelected ? this.trans[genreSelected] : this.trans.genre;
        },
        snackbarText() {
            return this.snackbarType === "success"
                ? this.trans.updated
                : this.trans.error;
        },
    },

    methods: {
        localizeErrors() {
            localize({
                ca: {
                    messages: {
                        required: "Aquest camp és obligatori",
                        email: "Aquest correu electrònic no és vàlid",
                        regex: "La data de naixement (dd/mm/aaaa) no és vàlida"
                    }
                },
                es: {
                    messages: {
                        required: "Este campo es obligatorio",
                        email: "Este correo electrónico no es válido",
                        regex:
                            "La fecha de nacimiento (dd/mm/aaaa) no es válida"
                    }
                }
            });
            localize(window.appLocale);
        },
        toggleSelect(e) {
            if (e) {
                e.stopPropagation();
            }

            this.selectIsOpen = !this.selectIsOpen;

            if (this.selectIsOpen) {
                document.body.addEventListener(
                    "click",
                    () => {
                        this.selectIsOpen = false;
                    },
                    { once: true }
                );
            }
        },
        handleSelectBlur() {
            this.selectError = !this.form.genre;
        },
        setGenre(value) {
            this.form.genre = value;
        },
        buttonIsDisabled(invalid) {
            return invalid || !this.form.genre;
        },
        async send() {
            this.loading = true;
            this.snackbar = false;
            try {
                await axios.post("/wizard-matriculation-form", {
                    ...this.form,
                    email: this.email,
                    code: this.code,
                    locale: this.locale,
                });
                this.snackbarType = "success";
                setTimeout(() => {
                    window.location.href = '/';
                }, 2000);
            } catch (e) {
                this.snackbarType = "fail";
            }
            this.loading = false;
            this.snackbar = true;
        },
    },

    created() {
        this.localizeErrors();
        const params = new URLSearchParams(window.location.search);
        this.email = params.get("email");
        this.code = params.get("c");
        this.locale = params.get("lang");
    }
};
</script>
